import React from "react";
import _ from "lodash";
import { formatTextWithFallback } from "../../../helpers/helpers";

function LivePeopleExpandable({ data, secondaryProperty }) {
  return (
    <>
      <div className="table-expaned-data">
        <div className="item">
          Profile ID{" "}
          <div className="value">
            {formatTextWithFallback(data?.data?.profile_id)}
          </div>
        </div>
        <div className="item">
          Status{" "}
          <div className="value">
            {_.startCase(formatTextWithFallback(data?.data?.profile_status))}
          </div>
        </div>
        <div className="item">
          Access Control{" "}
          <div className="value">
            {formatTextWithFallback(data?.data?.dev_name)}
          </div>
        </div>
        <div className="item">
          {_.capitalize(secondaryProperty())}{" "}
          <div className="value">
            {formatTextWithFallback(data?.data?.[secondaryProperty()])}
          </div>
        </div>
      </div>
    </>
  );
}

export default LivePeopleExpandable;
